import { pslClient } from "@/common/http-common";
import {
  API_URL_GET_OCCUPATIONS,
  API_URL_GET_INDUSTRIES,
  API_URL_GET_PRODUCTS,
  API_URL_GET_SYSTEM,
  API_URL_GET_PRODUCT_PRICING,
} from "@/constants/api.constants.js";

class CatalogueService {
  occupation(config) {
    return pslClient.get(API_URL_GET_OCCUPATIONS, config).then((res) => {
      return res.data;
    });
  }
  industry(config) {
    return pslClient.get(API_URL_GET_INDUSTRIES, config).then((res) => {
      return res.data;
    });
  }
  product(config) {
    return pslClient.get(API_URL_GET_PRODUCTS, config).then((res) => {
      return res.data;
    });
  }
  system(config) {
    return pslClient.get(API_URL_GET_SYSTEM, config).then((res) => {
      return res.data;
    });
  }
  async getProductPricing(productId, config) {
    const url = `${API_URL_GET_PRODUCT_PRICING}/${productId}`;

    const res = await pslClient.get(url, config);

    return res.data;
  }
}

export default new CatalogueService();
